import { cellRenderParseData } from '../../../utils/functions';

const semiDataGrid = [
  {
    dataField: 'qcId',
    caption: 'СК',
    dataType: 'string'
  },
  {
    dataField: 'accountingDate',
    cellRender: cellRenderParseData,
    caption: 'Дата СК(рулон)',
    dataType: 'string'
  },
  {
    dataField: 'batchId',
    caption: 'Партия SAP',
    dataType: 'string'
  },
  {
    dataField: 'cgId',
    caption: 'Номер партии',
    dataType: 'string'
  },
  {
    dataField: 'actualPieceId',
    caption: 'Номер УЕ',
    dataType: 'string'
  },
  {
    dataField: 'psStatusName',
    caption: 'Статус УЕ',
    dataType: 'string'
  },
  {
    dataField: 'quantity',
    caption: 'Кол-во',
    dataType: 'number'
  },
  {
    dataField: 'quantityRemain',
    caption: 'Кол-во ост.',
    dataType: 'number'
  },
  {
    dataField: 'weightEndProduct',
    caption: 'Кол-во ГП',
    dataType: 'number'
  },
  {
    dataField: 'percentWasteMaterial',
    caption: '% отходов',
    dataType: 'number'
  },
  {
    dataField: 'zdvlOrderNumId',
    caption: 'Заказ ZDVL',
    dataType: 'number'
  },
  {
    dataField: 'zdvlLineId',
    caption: 'Позиция ZDVL',
    dataType: 'string'
  },
  {
    dataField: 'checkbox',
    caption: 'Тип чекбокса',
    notVisible: true,
    dataType: 'string'
  },
  {
    dataField: 'incomingDate',
    caption: 'Дата приемки',
    notVisible: true,
    dataType: 'string'
  },
  {
    dataField: 'pieceNumId',
    caption: 'id ПФ',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'psStatusNumId',
    caption: 'id статуса',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'thick',
    caption: 'Толщина ПФ',
    dataType: 'number'
  },
  {
    dataField: 'width',
    caption: 'Ширина ПФ',
    dataType: 'number'
  },
  {
    dataField: 'readyProfileSize',
    caption: 'Профилеразмер ГП',
    dataType: 'string'
  },
  {
    dataField: 'readyLength',
    caption: 'Длина ГП',
    dataType: 'number'
  },
  {
    dataField: 'mark',
    caption: 'Марка стали',
    dataType: 'string'
  },
  {
    dataField: 'taskNumber',
    caption: 'Номер задания',
    dataType: 'string'
  },
  {
    dataField: 'pieceId',
    caption: 'Маркировка',
    dataType: 'string'
  }
];

export default semiDataGrid;
